import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

export interface HeaderConfiguration {
  layoutAlign: string;
  sections: Sections[];
}

export interface Sections {
  backButton?: BackButton;
  nextButton?: NextButton;
  menu?: boolean;
  menuDesktop?: boolean;
}

export interface BackButton {
  content?: string;
  output?: boolean;
  styles?: Array<string>;
  route?: string;
  relativeRoute?: boolean;
  isDialog?: boolean;
}

export interface NextButton {
  content: string;
  styles?: Array<string>;
  route: string;
  relativeRoute?: boolean;
  isDialog?: boolean;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() configuration: HeaderConfiguration;
  @Input() disabledNotification = true;
  @Output() onClickButton = new EventEmitter<any>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  goToPreviousPage(): void {
      this.onClickButton.emit();
  }

  goToNextPage(route: string, relativeRoute: boolean): void {
    relativeRoute
      ? this.router.navigate([route], { relativeTo: this.route })
      : this.router.navigate([route]);
  }

  checkStyles() {
    // let desktop;
    // this.configuration.sections.forEach(section => desktop = section.menuDesktop)
    // return desktop ? { display: 'block!important' } : { display: 'flex' };
  }
}
